/* ==============================================================
   TTW - "Pay in 2 interest-free installments... Shop Pay" text
   ko "Buy with Shop" button ke NEECHE le jao (17 Aug 2026)

   MASLA: "installment text ko 'Buy with Shop' button k neechay
   laga dain" - assets/ttw-inline.js (ttw-pdp script #2) mein pehle
   se ek reflowPriceBits() function maujood hai jo bilkul yehi karta
   hai (.price-descriptors ko .buy-buttons-row ke turant baad move
   kar deta hai), lekin us mein ek guard hai:

     if (!descriptors.textContent || !tidy(descriptors.textContent)) return;

   Installment text asal mein Shopify ke <shopify-payment-terms>
   web component ke SHADOW DOM ke andar render hota hai - browser
   ka .textContent shadow DOM ke andar nahi jhaakta, is liye
   descriptors.textContent HAMESHA khali (sirf whitespace) rehta
   hai, chahe widget visually text dikha raha ho. Nateeja: guard
   hamesha true, function hamesha turant return kar deta hai, move
   KABHI nahi hota - installment text hamesha price ke neeche,
   buttons ke UPAR hi raha reh jata hai (live product page par
   verify kiya: descriptors.textContent.trim().length === 0 jabke
   widget khud visually text dikha raha tha).

   HAL: chhoti alag file (established practice - purani file ko
   dobara upload/edit nahi karna, ttw-inline.js ke andar reflowPrice-
   Bits() jaisa hi kaam, magar SAHI guard ke sath - "descriptors mein
   koi element bacha hai ya nahi" dekhte hain (form/custom-element
   DOM mein turant maujood hota hai, shadow DOM populate hone ka
   intezar nahi karna parta), "khali text" nahi. Doosri script
   ka reflowPriceBits() apni jagah rehne deta hai (wo bas kabhi
   kuch nahi karta, koi nuqsan nahi) - ye nayi file wahi move khud,
   sahi tarah se, karti hai.

   ---- ROUND 31 (20 Aug 2026): AB DESKTOP + DRAWER PAR BHI ----
   Anwar's naya ask (Roman Urdu, gist): "DRAWER aur Product page
   per price k neechey jo text likha hai 'Pay in 2 interest-free
   installments...' iko 'BUY WITH SHOP' button k neechey likh dain"
   - yani DONO jagah (PDP aur Quick Add drawer), koi device-limit
   ka zikar nahi tha.

   Is file ka naam "mobile" keh raha hai kyunke pehli baar sirf
   mobile ka masla report hua tha, isi liye `if (window.innerWidth
   > 749) return;` guard laga diya gaya tha (jaan-boojh kar, taake
   desktop ka mojooda layout na chhide bina zaroorat). Ab Anwar ne
   dono devices ka poochha hai, is liye wo guard hata diya gaya hai
   - filename (asset ka URL) nahi badla taake koi doosri jagah se
   is file ka reference na toote (established practice - files ko
   naam se nahi, sirf zaroorat ke mutabiq content se badalte hain).

   .product-detail selector (root querySelectorAll neeche) pehle se
   hi PDP aur Quick Add drawer DONO ko cover karta hai - sections/
   main-product.liquid mein ".product-detail quickbuy-content" ek
   hi wrapper class hai jo dono jagah istemal hoti hai (dekhein
   assets/ttw-round14-quantity.css ke comments - wahi jagah jahan
   ".js-quickbuy" ko drawer-only ancestor banaya gaya tha; yahan
   koi drawer/PDP farq zaroori nahi tha kyunke Anwar ne dono ka
   pocha, is liye simple ".product-detail" root hi kaafi hai, PDP
   aur drawer dono render mein yahi class maujood hoti hai).
   ============================================================== */
(function () {
  'use strict';

  function move() {
    var containers = document.querySelectorAll('.product-detail');
    Array.prototype.forEach.call(containers, function (root) {
      var form = root.querySelector('.product-form');
      if (!form) return;
      var descriptors = form.querySelector('.price-descriptors');
      var buyRow = form.querySelector('.buy-buttons-row');
      if (!descriptors || !buyRow) return;
      if (!descriptors.firstElementChild) return; // widget abhi tak render hi nahi hua
      if (descriptors.previousElementSibling === buyRow) return; // already moved
      buyRow.parentNode.insertBefore(descriptors, buyRow.nextSibling);
    });
  }

  function start() {
    move();
    var onPDP = document.body.classList.contains('template-product');
    if (!onPDP || !window.MutationObserver) return;
    var host = document.querySelector('.detail.product-column-right') || document.querySelector('.product-detail');
    if (!host) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(move, 80);
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('resize', move);
  /* Shop Pay ka <shopify-payment-terms> widget deir se (async) apna
     content bharta hai - chand fallback re-checks taake move us
     waqt ho jaye jab element DOM mein aa jaye. Quick Add drawer ke
     liye bhi zaroori hai, jo PDP se der se, click par khulta hai. */
  setTimeout(move, 600);
  setTimeout(move, 1500);
  setTimeout(move, 3000);

  /* Round 31: Quick Add drawer content JS se DOM mein baad mein
     inject hota hai (click ke baad) - upar wale fixed-delay
     fallbacks us waqt tak drawer khula hi nahi hota. Isi liye
     drawer khulne ka mauka bhi khud sunte hain aur turant re-run
     karte hain. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.quickbuy-toggle')) {
      setTimeout(move, 400);
      setTimeout(move, 900);
      setTimeout(move, 1800);
    }
  });
})();
